var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_flag_24px")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Travelers---United-States-Search",
    transform: "translate(-59.000000, -423.000000)",
    fill: "#006FAE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_flag_24px",
    transform: "translate(59.000000, 423.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "10.0266667 2.13333333 9.6 0 0 0 0 18.1333333 2.13333333 18.1333333 2.13333333 10.6666667 8.10666667 10.6666667 8.53333333 12.8 16 12.8 16 2.13333333"
  }))))));
};

export default __webpack_public_path__ + "static/media/Flag.28390ad7.svg";
export { SvgComponent as ReactComponent };